var UitkDateRangeGridThemeMap = [
    ['default', ''],
    ['negative', 'negative'],
    ['positive', 'positive'],
    ['link', 'link'],
    ['selected-cell', 'selected-cell'],
    ['selected-header', 'selected-header'],
    ['unavailable', 'unavailable']
];
var UitkDateRangeGridHeaderTheme;
(function (UitkDateRangeGridHeaderTheme) {
    UitkDateRangeGridHeaderTheme["SELECTED_HEADER"] = "selected-header";
    UitkDateRangeGridHeaderTheme["DEFAULT"] = "default";
})(UitkDateRangeGridHeaderTheme || (UitkDateRangeGridHeaderTheme = {}));
var UitkDateRangeGridCellTheme;
(function (UitkDateRangeGridCellTheme) {
    UitkDateRangeGridCellTheme["SELECTED_CELL"] = "selected-cell";
})(UitkDateRangeGridCellTheme || (UitkDateRangeGridCellTheme = {}));

export { UitkDateRangeGridCellTheme, UitkDateRangeGridHeaderTheme, UitkDateRangeGridThemeMap };
